module.exports = __webpack_public_path__ + "img/p62-berkeley-library.0664dc63.jpg";